export default __webpack_public_path__ + "static/media/STRIP-LogoBGVer.e41d22d8.png";